import useSWR from "swr";
import { MessageCostSummary } from "@/models/MessageCost";
import { MessageCostService } from "@/services/messageCost/messageCost.service";
import { useWorkspaces } from "./useWorkspaces";

export const getMessageCostSummaryKey = (workspaceId: string | undefined) => {
  if (!workspaceId) return null;
  return ["message-cost-summary", workspaceId];
};

export const useMessageCostSummary = () => {
  const { sessionCurrentWorkspaceId } = useWorkspaces();

  const { data, error, mutate, isLoading } = useSWR<MessageCostSummary>(
    getMessageCostSummaryKey(sessionCurrentWorkspaceId),
    ([, workspaceId]: [string, string]) => MessageCostService.getMessageCostSummary(workspaceId),
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
};
